export default __webpack_public_path__ + "static/media/piping_type.570725c2.jpeg";